import React, { useEffect } from 'react';

const ROWS = [
	['network', 'Network'],
	['server', 'Server'],
	['client', 'Client'],
	['other', 'Other'],
];

const ms = n => `${Math.round(n)} ms`;

/** The body: this page's timings, quiet and tabular. */
export function PageStatsBody({ stats }) {
	if (!stats) {
		return <p className="page-stats__note" data-testid="page-stats-empty">No timings for this page yet. Open it again after it loads.</p>;
	}
	return (
		<div className="page-stats" data-testid="page-stats">
			<dl className="page-stats__list">
				<div className="page-stats__row page-stats__row--total">
					<dt>Total</dt>
					<dd data-stat="total">{ms(stats.total)}</dd>
				</div>
				{ROWS.map(([key, label]) => (
					<div className="page-stats__row" key={key}>
						<dt>{label}</dt>
						<dd data-stat={key}>{stats[key] === null ? 'Unavailable' : ms(stats[key])}</dd>
					</div>
				))}
			</dl>
			{stats.serverKnown ? null : (
				<p className="page-stats__note">Server time is unavailable: this API did not report it, so its wait is counted as network.</p>
			)}
			<p className="page-stats__note">Measured in your browser. Nothing is sent or saved.</p>
		</div>
	);
}

/**
 * Closes the stats on Escape or a press outside them. Called once, by the shell.
 */
export function usePageStatsDismiss(open, onClose) {
	useEffect(() => {
		if (!open) return undefined;
		const onKey = event => { if (event.key === 'Escape') onClose(); };
		const onDown = event => {
			if (event.target && event.target.closest && event.target.closest('.page-stats-popover')) return;
			onClose();
		};
		document.addEventListener('keydown', onKey);
		document.addEventListener('mousedown', onDown);
		return () => {
			document.removeEventListener('keydown', onKey);
			document.removeEventListener('mousedown', onDown);
		};
	}, [open, onClose]);
}

/**
 * Props for a controlled antd Popover wrapped directly around the account
 * menu's trigger (the Dropdown wraps the Popover). It has to be antd's own
 * Popover there, which forwards the ref the Dropdown needs.
 */
export function pageStatsPopoverProps({ open, stats, placement }) {
	return {
		open,
		trigger: [],
		placement,
		title: 'Page stats',
		content: <PageStatsBody stats={stats} />,
		overlayClassName: 'page-stats-popover',
		destroyTooltipOnHide: true,
	};
}
